module.exports = "../images/house-keeping-package.jpg?v=18e5ecd";